import React from "react";
import ReactTooltip from "react-tooltip";
import Fonts from "../assets/Fonts";

import styles from "./tooltip.module.css";

function Tooltip({
  text,
  children,
  className,
  position = "bottom",
  tooltipStyle,
}) {
  const randomId = Math.ceil(Math.random() * 1000);
  return (
    <div className={[className].join(" ")}>
      <a
        data-tip
        data-for={`tooltip${randomId}`}
        className={[styles["link"]].join(" ")}
      >
        {children}
      </a>

      <ReactTooltip
        id={`tooltip${randomId}`}
        type="dark"
        effect="solid"
        place={position}
        className={styles.tooltip}
        style={{ ...Fonts.p2, ...tooltipStyle }}
        // data-event-off="mouseleave click"
      >
        {text}
      </ReactTooltip>
    </div>
  );
}

export { Tooltip };
